import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { Input, Button, Message } from 'semantic-ui-react'
import Moment from 'moment'
import DateTime from 'react-datetime'
import Form from '../Form'

import 'react-datetime/css/react-datetime.css'
import './DateInput.css'

require('moment/locale/fr-ch')

class DateInput extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      isPickerOpen: false,
      dateReadable: _.isNull(props.value)
        ? ''
        : Moment(props.value).format('DD.MM.YYYY'),
      dateJson: props.value,
      error: null
    }

    // Bind events
    this.renderInput = this.renderInput.bind(this)
    this.onClickCalButton = this.onClickCalButton.bind(this)
    this.onChangeInput = this.onChangeInput.bind(this)
    this.onBlurInput = this.onBlurInput.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    // When closing datepicker, error can be cleared
    if (
      prevState.isPickerOpen
      &&
      !this.state.isPickerOpen
      &&
      !_.isNull(this.state.dateJson)
    ) {
      this.setState({
        error: null
      })
    }

    // When receiving new value, update
    if (
      prevProps.value !== this.props.value
      &&
      !_.isNull(this.props.value)
    ) {
      this.setState({
        dateJson: this.props.value,
        dateReadable: _.isNull(this.props.value)
          ? ''
          : Moment(this.props.value).format('DD.MM.YYYY')
      })
    }

    // When JSON date changes, trigger onChange with parent
    if (
      prevState.dateJson !== this.state.dateJson
    ) {
      this.props.onChange(this.state.dateJson)
    }
  }

  renderInput(pickerProps) {
    return (
      <Input
        type='text'
        action={true}
        error={!_.isNull(this.state.error)}
        value={pickerProps.value}
        onChange={pickerProps.onChange}
        onBlur={this.onBlurInput}
      >
        <input />
        <Button
          as='div'
          icon='calendar'
          onClick={this.onClickCalButton}
          tabIndex={-1}
        />
      </Input>
    )
  }

  onClickCalButton() {
    this.setState((prevState) => ({
      isPickerOpen: !prevState.isPickerOpen
    }))
  }

  onChangeInput(newDate) {
    this.setState((prevState, props) => (_.extend(
      {
        isPickerOpen: false
      },
      _.isString(newDate)
        ? {
            dateReadable: newDate,
            dateJson: null,
            error: null
          }
        : _.extend(
            {
              dateReadable: newDate.format('DD.MM.YYYY')
            },
            {
              dateJson: newDate.format('YYYY-MM-DD'),
              error: null
            }
          )
    )))
  }

  onBlurInput() {
    this.setState((prevState, props) => {
      if (_.isNull(prevState.dateJson)) {
        if (_.isString(prevState.dateReadable) && prevState.dateReadable.length > 0) {
          return {
            error: "La date saisie n'est pas valide."
          }
        }
        else {
          if (props.allowBlurEmpty) {
            return {
              error: null
            }
          }
          else {
            return {
              error: "Veuillez sélectionner une date."
            }
          }
        }
      }
      else {
        return {
          error: null
        }
      }
    })
  }

  renderError() {
    let errorStr = _.isString(this.props.error)
      ? this.props.error
      : (
          _.isNull(this.state.error)
            ? null
            : this.state.error
        )
    return (
      _.isNull(errorStr)
        ? null
        : <Message
            className='datepicker-bottom-error'
            negative={true}
            compact={true}
            attached='bottom'
            size='tiny'
            content={errorStr}
          />
    );
  }

  render() {
    const input = (
      <div>
        <DateTime
          renderInput={this.renderInput}
          dateFormat={true}
          timeFormat={false}
          open={this.state.isPickerOpen}
          value={this.state.dateReadable}
          onChange={this.onChangeInput}
        />
        { this.renderError() }
      </div>
    )
    return (
      _.isString(this.props.label)
        ? <React.Fragment>
            <Form.Row
              error={!!this.state.error}
            >
              <label>
                {this.props.label}
              </label>
              {input}
            </Form.Row>
          </React.Fragment>
        : input
    )
  }
}

DateInput.propTypes = {
  label: PropTypes.string, // if missing, rendered without Form structure
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  allowBlurEmpty: PropTypes.bool.isRequired,
  error: PropTypes.string
}

export default DateInput



// WEBPACK FOOTER //
// ./src/components/elements/forms/DateInput.js